/* eslint-disable import/no-anonymous-default-export */
export default {
  configuration: {
    loadingConfig: false,
    dataConfig: null,
    errorConfig: null,
  },
};
